import React from 'react';

import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const BooleanSelector = ({ onChange, value, disabled, emptyValue }) => {
    const options = [
        { label: 'Yes', value: true, icon: byPrefixAndName.fasl['thumbs-up'] },
        { label: 'No', value: false, icon: byPrefixAndName.fasl['thumbs-down'] },
    ];

    return (
        <RadioButtonGroup value={value} disabled={disabled} defaultValue={null} onChange={onChange} options={options} />
    );
};

export default BooleanSelector;
